 $('.testimonial-slider').owlCarousel({
            loop:true,
            margin:10,
            dots:true,
            nav:false,
            items: 1,
        })
        $(document).ready(function(){
            // Rating wrapper click handler for smooth scroll to reviews
            $('.rating-wrapper-responsive').on('click', function(e) {
                e.preventDefault();
                console.log('Rating wrapper clicked!'); // Debug log
                const reviewsSection = $('.cst-reviews-section');
                console.log('Reviews section found:', reviewsSection.length); // Debug log
                if (reviewsSection.length) {
                    $('html, body').animate({
                        scrollTop: reviewsSection.offset().top - 80
                    }, 800);
                }
            });
            
    var firstSlider = $('.testimonials');
    var secondSlider = $('.testimonials2');
    var flag = false;

    firstSlider.owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: false,
        items: 5,
        center: true,
        responsive:{
          0:{
            items:3,
          },
          992:{
            items:5,
          }
        }
    });

    secondSlider.owlCarousel({
        loop: true,
        margin: 10,
        dots: true,
        nav: false,
        items: 1,
        center: true,
        animateOut: 'owl-fade-out'
    });

    firstSlider.on('changed.owl.carousel', function(event) {
        if (!flag) {
            flag = true;
            var currentIndex = event.item.index;
            secondSlider.trigger('to.owl.carousel', [currentIndex, 300, true]);
            flag = false;
        }
    });

    secondSlider.on('changed.owl.carousel', function(event) {
        if (!flag) {
            flag = true;
            var currentIndex = event.item.index;
            firstSlider.trigger('to.owl.carousel', [currentIndex, 300, true]);
            flag = false;
        }
    });
    
});

// Vanilla JavaScript version for rating wrapper scroll functionality (no jQuery dependency)
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, looking for rating wrapper...'); // Debug log
    const ratingWrapper = document.querySelector('.rating-wrapper-responsive');
    console.log('Rating wrapper found:', ratingWrapper); // Debug log
    
    if (ratingWrapper) {
        ratingWrapper.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Rating wrapper clicked (vanilla JS)!'); // Debug log
            const reviewsSection = document.querySelector('.cst-reviews-section');
            console.log('Reviews section found (vanilla):', reviewsSection); // Debug log
            
            if (reviewsSection) {
                // Check if element is visible
                const isVisible = reviewsSection.offsetParent !== null;
                console.log('Reviews section is visible:', isVisible); // Debug log
                
                if (isVisible) {
                    const offsetTop = reviewsSection.getBoundingClientRect().top + window.pageYOffset - 80;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                } else {
                    console.log('Reviews section is hidden, cannot scroll to it');
                }
            }
        });
        
        // Add visual indication that element is clickable
        ratingWrapper.style.cursor = 'pointer';
        ratingWrapper.setAttribute('title', 'Click to view reviews');
    }
});